import { ProjectDisallowance } from '@neo.tax/shared';

const RD_PROJECT_DISALLOWANCES_FORM_DICT = {
  [ProjectDisallowance.AdaptationForCustomer]: false,
  [ProjectDisallowance.InternalUseSoftware]: false,
  [ProjectDisallowance.ResearchFundedByGrantContractEtc]: false,
  [ProjectDisallowance.ResearchIntoSocialSciences]: false,
  [ProjectDisallowance.ResearchOutsideUs]: false,
  [ProjectDisallowance.ReverseEngineering]: false,
  [ProjectDisallowance.SurveyOrMarketResearch]: false,
  [ProjectDisallowance.TestingOrQaInProduction]: false,
};

export const RD_PROJECT_DISALLOWANCES = [
  ProjectDisallowance.AdaptationForCustomer,
  ProjectDisallowance.InternalUseSoftware,
  ProjectDisallowance.ResearchFundedByGrantContractEtc,
  ProjectDisallowance.ResearchIntoSocialSciences,
  ProjectDisallowance.ResearchOutsideUs,
  ProjectDisallowance.ReverseEngineering,
  ProjectDisallowance.SurveyOrMarketResearch,
  ProjectDisallowance.TestingOrQaInProduction,
];

export const reduceRdProjectDisallowances = (
  mapper: (disallowance: ProjectDisallowance) => boolean,
): { [key in ProjectDisallowance]: boolean } =>
  RD_PROJECT_DISALLOWANCES.map((disallowance) => ({
    [disallowance]: mapper(disallowance),
  })).reduce((acc: { [key in ProjectDisallowance]: boolean }, curr) => ({ ...acc, ...curr }), {
    ...RD_PROJECT_DISALLOWANCES_FORM_DICT,
  });
